import { Checkbox, FormControlLabel } from '@mui/material';
import { useSilentWitnessContext } from '../../contexts/SilentWitnessContext';
import { silentWitnessClasses } from './silentWitnessClasses';
import { cn } from "../../utils/classNames";

const fileItemCardClasses = 'flex justify-between items-center mb-3 p-3';

const SilentWitnessFileItem = ({ item, groupKey }) => {
  const { selectedLiabilityItems, toggleItemSelection } = useSilentWitnessContext();
  const key = `${groupKey}-${item.index}`;
  const selection = selectedLiabilityItems[key] || { plaintiff: false, defendant: false };

  return (
    <div className={cn(fileItemCardClasses, silentWitnessClasses.itemCard)}>
      <div className={silentWitnessClasses.itemNameWrapper}>
        <span className={silentWitnessClasses.itemName}>
          {item.name}
        </span>
      </div>

      <div className={silentWitnessClasses.checkboxGroup}>
        <FormControlLabel
          className={silentWitnessClasses.formControlLabel}
          label={<span className={silentWitnessClasses.labelText}>Plaintiff</span>}
          control={
            <Checkbox
              checked={selection.plaintiff}
              onChange={() =>
                toggleItemSelection({
                  itemKey: groupKey,
                  index: item.index,
                  type: 'plaintiff',
                })
              }
              size="medium"
            />
          }
        />

        <FormControlLabel
          className={silentWitnessClasses.formControlLabel}
          label={<span className={silentWitnessClasses.labelText}>Defendant</span>}
          control={
            <Checkbox
              checked={selection.defendant}
              onChange={() =>
                toggleItemSelection({
                  itemKey: groupKey,
                  index: item.index,
                  type: 'defendant',
                })
              }
              size="medium"
            />
          }
        />
      </div>
    </div>
  );
};

export default SilentWitnessFileItem;
